import { DList, DListResponse } from 'models/common.model';

export const MEDIA_TYPES = {
  IMAGE: 1,
  VIDEO: 2,
  GIF: 3,
};

export type MediaAdsModel = {
  id: number;
  name: string;
  mediaUrl: string;
  mediaType: number;
  orderNo: number;
};

export type MediaPlaylistRequestModel = {
  queryString?: string;
  pageIndex: number;
  pageSize: number;
};

export type PlaylistMediaResponseModel = DListResponse<MediaAdsModel[]>;

export interface PlaylistStateModel {
  mediaPlaylist: DList<MediaAdsModel>;
  loadingInList: boolean;
}
